import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase/client';
import { toast } from 'sonner';

export function VerifyHandler() {
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Get current session
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          toast.error('Please sign in to complete verification');
          navigate('/auth/sign-in');
          return;
        }

        if (session.user.email_confirmed_at) {
          toast.success('Email verified successfully!');
          navigate('/dashboard');
        } else {
          toast.info('Please check your email to complete verification');
          navigate('/auth/sign-in');
        }
      } catch (error) {
        console.error('Verification failed:', error);
        toast.error('Failed to verify email');
        navigate('/auth/sign-in');
      } finally {
        setVerifying(false);
      }
    };

    verifyEmail();
  }, [navigate]);

  if (verifying) {
    return <div>Verifying your email...</div>;
  }

  return null;
} 